// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__31_av","header":"ReportDetails_header__18sKm","title":"ReportDetails_title__1uvTM","left":"ReportDetails_left__3Ighb"};